<template>
  <FlotoFixedView>
    <MRow class="h-100">
      <MCol :size="12" class="flex flex-col h-100">
        <MRow :gutter="0" class="px-4">
          <MCol :sm="4" :size="12">
            <FlotoPageHeader
              :title="
                selfServiceType === 'reset_password'
                  ? $tc('header_reset_password')
                  : $tc('header_unlock_account')
              "
              use-divider
            >
              <span class="text-neutral"
                >{{ $tc('answer_questions') }} {{ ':' }}</span
              >
            </FlotoPageHeader>
          </MCol>
          <FlotoScrollView :sm="4" :size="12">
            <FlotoContentLoader :loading="loading">
              <FlotoForm @submit="verifyAnswer">
                <MRow :gutter="0" class="px-4">
                  <MCol :sm="4" :size="12">
                    <FlotoFormItem
                      v-model="configuredQuestions[index]"
                      disabled
                      :label="`${$tc('question')} ${$tc(index + 1)}`"
                    />
                  </MCol>
                </MRow>
                <MRow :gutter="0" class="px-4">
                  <MCol :sm="4" :size="12">
                    <PasswordInput
                      v-model="answer"
                      :placeholder="$tc('answer')"
                      :label="$tc('answer')"
                      rules="min:5|required|short_text"
                    >
                    </PasswordInput>
                  </MCol>
                </MRow>
                <template v-slot:submit>
                  <MRow :gutter="0" class="px-4 text-right">
                    <MCol :sm="4" :size="12">
                      <MButton
                        class="mr-2"
                        type="submit"
                        :loading="inProgress"
                        outline
                      >
                        {{ $tc('verify') }}
                      </MButton>
                      <FlotoLink
                        as-button
                        outline
                        :to="$currentModule.getRoute('self-service')"
                      >
                        {{ $tc('cancel') }}
                      </FlotoLink>
                    </MCol>
                  </MRow>
                </template>
              </FlotoForm>
            </FlotoContentLoader>
          </FlotoScrollView>
        </MRow>
      </MCol>
    </MRow>
  </FlotoFixedView>
</template>

<script>
import { validateAnswerApi, unlockAccountApi } from '../support-portal-api'
import PasswordInput from '@components/password-input'
export default {
  name: 'QuestionAnswerPortal',
  components: { PasswordInput },
  data() {
    this.configuredQuestions = this.$route.params.configuredQuestions
    this.selfServiceType = this.$route.params.selfServiceType
    this.email = this.$route.params.email
    return {
      index: 0,
      answer: '',
      inProgress: false,
      loading: false,
    }
  },
  methods: {
    verifyAnswer() {
      this.inProgress = true
      validateAnswerApi(
        this.configuredQuestions[this.index],
        this.answer,
        this.email,
        this.selfServiceType
      )
        .then(() => {
          this.loading = true
          this.answer = ''
          if (this.index < this.configuredQuestions.length - 1) {
            setTimeout(() => {
              this.index = this.index + 1
              this.loading = false
            }, 400)
          }
          if (this.index === this.configuredQuestions.length - 1) {
            if (this.selfServiceType === 'reset_password') {
              this.$router.replace(
                this.$currentModule.getRoute('reset-password', {
                  params: { email: this.email },
                })
              )
            } else if (this.selfServiceType === 'unlock_account') {
              this.inProgress = true
              unlockAccountApi({ email: this.email })
                .then(() => {
                  this.$router.replace(
                    this.$modules.getModuleRoute('auth', 'login')
                  )
                })
                .finally(() => {
                  this.inProgress = false
                  this.loading = false
                })
            }
          }
        })
        .finally(() => {
          this.inProgress = false
        })
    },
  },
}
</script>
